export default function Analysis({ color }: { color: string; }) {
  return (
    <svg width='24' height='24' viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.4 8.55V7.65M9 8.55V6.75M12.6 8.55V4.95M7.2 12.15L5.85 15.75M12.4452 15.7L10.8542 12.1998M3.6 12.15C2.60589 12.15 1.8 11.3441 1.8 10.35V4.05C1.8 3.05589 2.60589 2.25 3.6 2.25H14.4C15.3941 2.25 16.2 3.05589 16.2 4.05V10.35C16.2 11.3441 15.3941 12.15 14.4 12.15H3.6Z" stroke={color} strokeOpacity='1' strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}